export enum InfoOnWorkerType {
  TAUX_HORAIRE = 1,
  MATRICULE = 2,
  TAILLE_BLOUSE = 4,
  DATE_ANCIENNETE = 5,
  CLASSIFICATION_FHP = 6,
  IDENTIFIANT_OCTIME = 8,
  COEF_FHP = 9,
  IDENTIFIANT_CHRONOS = 10,
  COMPTEUR_N_MOINS_UN = 11,
  ECHELON = 12,
  IDENTIFIANT_AGILETIME = 13,
  PRIME_SALAIRE_MENSUEL = 14,
  NIVEAU_DE_RMAG = 15,
  STATUT_ETUDIANT = 16,
  IDENTIFIANT_CEGI = 23,
}
